import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { routes } from "Constant/routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { setTemplate } from "../../../../redux/slices/templates/templates.slice";

const Template = ({
    logo,
    source,
    destination,
    isDestinationOptional,
    title,
    description,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate(routes.wizard);
        dispatch(
            setTemplate({
                source,
                destination,
                isDestinationOptional,
            }),
        );
    };

    return (
        <Card
            onClick={handleOnClick}
            sx={{
                height: "100%",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                borderRadius: "10px",
                border: "1px solid rgba(0,0,0,0.05)",
                boxShadow: "none",
                transition: "transform 0.2s ease",
                "&:hover": {
                    transform: "translateY(-2px)",
                },
            }}
        >
            <CardContent sx={{ position: "relative", height: "100%" }}>
                <Stack spacing={2} height="100%">
                    <Box
                        sx={{
                            width: "fit-content",
                            p: 1.5,
                            borderRadius: "10px",
                            backgroundColor: "rgba(0,0,0,0.02)",
                            display: "flex",
                        }}
                    >
                        <img
                            src={logo}
                            alt={title}
                            style={{ width: "2rem", height: "2rem" }}
                        />
                    </Box>
                    <Box>
                        <Typography
                            fontWeight={700}
                            fontSize={16}
                            whiteSpace="nowrap"
                        >
                            {title}
                        </Typography>
                    </Box>
                    <Box marginBottom="16px !important">
                        <Typography fontSize={14} color="text.secondary">
                            {description}
                        </Typography>
                    </Box>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        gap={0.5}
                        marginTop="auto !important"
                        color="#000000"
                    >
                        <Typography
                            fontWeight={700}
                            fontSize={"0.875rem"}
                            transition="opacity 0.2s ease"
                            sx={{
                                "&:hover": {
                                    opacity: 0.65,
                                },
                            }}
                        >
                            USE TEMPLATE
                        </Typography>
                        <ArrowForwardIcon sx={{ fontSize: 16 }} />
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default Template;
